import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

const certificatesList = [
  {
    id: "static-websites",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709214865/BUILD_YOUR_OWN_STATIC_WEBSITE_CERTIFICATE_page-0001_1_q0u2pa.jpg",
  },
  {
    id: "responsive-websites",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201448/BUILD_YOUR_OWN_RESPONSIVE_WEBSITE_CERTIFICATE_page-0001_a5cqea.jpg",
  },
  {
    id: "responsive-websites-flexbox",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709202118/RESPONSIVE_WEB_DESIGN_USING_FLEXBOX_CERTIFICATE_page-0001_nlzb1k.jpg",
  },
  {
    id: "python",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201489/PROGRAMMING_FOUNDATIONS_WITH_PYTHON_CERTIFICATE_page-0001_hffxwm.jpg",
  },
  {
    id: "dynamic-websites",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709193085/BUILD_YOUR_OWN_DYNAMIC_WEB_APPLICATION_CERTIFICATE_page-0001_agn2nl.jpg",
  },
  {
    id: "javascript",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201509/JAVASCRIPT_ESSENTIAL_CERTIFICATE_page-0001_b5an4e.jpg",
  },
  {
    id: "developer-foundations",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201853/DEVELOPER_FOUNDATION_CERTIFICATE_page-0001_rnhpnb.jpg",
  },
  {
    id: "database",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201532/INTRODUCTION_TO_DATABASE_CERTFICATE_page-0001_ex0tqo.jpg",
  },
  {
    id: "reactjs",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709202078/REACT_JS_CERTIFICATE_page-0001_xn0orq.jpg",
  },
  {
    id: "nodejs",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709201466/NODE_JS_CERTIFICATE_page-0001_yunr1v.jpg",
  },
  {
    id: "fundamentals",
    imgUrl:
      "https://res.cloudinary.com/dzmralqbm/image/upload/v1709202115/XPM_FUNDAMENTALS_CERTIFICATE_page-0001_cdjj2e.jpg",
  },
];

const ReactSlick = () => {
  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        {certificatesList.map((eachItem) => (
          <div key={eachItem.id} className="certificates-container">
            <img
              className="certificate"
              src={eachItem.imgUrl}
              alt={eachItem.id}
              loading="lazy"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ReactSlick;
